export default __webpack_public_path__ + "static/media/add-navigation-link.b79fb05e.svg";